import { render, staticRenderFns } from "./Drawings.vue?vue&type=template&id=73421937&scoped=true"
import script from "./Drawings.vue?vue&type=script&lang=js"
export * from "./Drawings.vue?vue&type=script&lang=js"
import style0 from "./Drawings.vue?vue&type=style&index=0&id=73421937&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73421937",
  null
  
)

export default component.exports